import {
  AccountStatuses,
  BreadAccount,
  BreadBudget,
  BreadTransaction,
  FirestoreDocCategory,
  FirestoreDocCategoryGroup,
  PlaidItemSafe,
} from "breadcommon";
import dayjs, { Dayjs } from "dayjs";
import {
  isBudgetActive,
  sortBudgetsByEndDesc,
} from "../budgets_screen/budgetUtils";

export function getHomeOverview(
  accounts: Map<string, BreadAccount>,
  plaidItems: Map<string, PlaidItemSafe>,
  transactions: Map<string, BreadTransaction>,
  budgets: Map<string, BreadBudget>,
  today: Dayjs = dayjs(),
) {
  const activeAccounts = Array.from(accounts.values()).filter(
    (a) => a.status === AccountStatuses.ACTIVE,
  );
  const attentionCount = activeAccounts.filter((account) => {
    const item = account.plaid_item_id
      ? plaidItems.get(account.plaid_item_id)
      : undefined;
    return (
      account.disappeared_from_plaid ||
      !item ||
      item.sync_errors?.account_sync_error ||
      item.sync_errors?.transaction_sync_error
    );
  }).length;
  const unreviewedCount = Array.from(transactions.values()).filter(
    (t) => !t.reviewed,
  ).length;
  const sortedBudgets = sortBudgetsByEndDesc(budgets);
  const activeBudgets = sortedBudgets.filter((b) => isBudgetActive(b, today));
  const endedBudget = sortedBudgets.find((b) =>
    today.isAfter(b.endDateTimestampSecs, "day"),
  );
  const upcomingBudget = sortedBudgets
    .filter((b) => today.isBefore(b.beginDateTimestampSecs, "day"))
    .sort(
      (a, b) =>
        a.beginDateTimestampSecs.valueOf() - b.beginDateTimestampSecs.valueOf(),
    )[0];
  return {
    accountCount: activeAccounts.length,
    attentionCount,
    transactionCount: transactions.size,
    unreviewedCount,
    reviewedCount: transactions.size - unreviewedCount,
    activeBudgets,
    endedBudget,
    upcomingBudget,
  };
}

export function countLabel(count: number, noun: string, plural = `${noun}s`) {
  return `${count.toLocaleString()} ${count === 1 ? noun : plural}`;
}

/** Counts the user's categories and the groups that hold them. */
export function getCategorySummary(
  categories: Map<string, FirestoreDocCategory>,
  categoryGroups: Map<string, FirestoreDocCategoryGroup>,
) {
  const groupCount = new Set(
    Array.from(categories.values())
      .map((c) => c.category_group_id)
      .filter((id) => categoryGroups.has(id)),
  ).size;
  return { categoryCount: categories.size, groupCount };
}
